import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  ResetPasswordRequest,
  login,
  signUp,
  SignUpRequest,
  resetPassword,
  verifySecurityCode,
  SecurityCodePayload,
  NewPasswordData,
  setNewPassword,
  AuthRequest,
  getUserFromCode,
  actualizarDatosUsuario,
  getUserFromID,
} from '@app/api/auth.api';
import { setUser } from '@app/api/slices/userSlice';
import { deleteToken, deleteUser, persistToken, readToken } from '@app/utils/localStorage.service';

export interface AuthSlice {
  token: string | null;
}

const initialState: AuthSlice = {
  token: readToken(),
};

export const doLogin = createAsyncThunk('auth/doLogin', async (loginPayload: AuthRequest, { dispatch }) =>
  login(loginPayload).then((res) => {
    dispatch(setUser(res.data.user));
    persistToken(res.data.access_token);

    return res.data.access_token;
  }),
);

export const doSignUp = createAsyncThunk('auth/doSignUp', async (signUpPayload: SignUpRequest) =>
  signUp(signUpPayload),
);

export const doGetUserFromCode = createAsyncThunk('auth/getUserFromCode', async (code: any) =>
  getUserFromCode(code).then((res) => {
    return res;
  }),
);

export const doActualizarDatosUsuario = createAsyncThunk('auth/actualizarDatosUsuario', async (data: any) =>
  actualizarDatosUsuario(data).then((res) => {
    return res;
  }),
);

export const doGetUserFromID = createAsyncThunk('auth/getUserFromID', async (id_usuario: any) =>
  getUserFromID(id_usuario).then((res) => {
    return res;
  }),
);

export const doResetPassword = createAsyncThunk(
  'auth/doResetPassword',
  async (resetPassPayload: ResetPasswordRequest) => resetPassword(resetPassPayload),
);

export const doVerifySecurityCode = createAsyncThunk(
  'auth/doVerifySecurityCode',
  async (securityCodePayload: SecurityCodePayload) => verifySecurityCode(securityCodePayload),
);

export const doSetNewPassword = createAsyncThunk('auth/doSetNewPassword', async (newPasswordData: NewPasswordData) =>
  setNewPassword(newPasswordData),
);

export const doLogout = createAsyncThunk('auth/doLogout', (payload, { dispatch }) => {
  deleteToken();
  deleteUser();
  dispatch(setUser(null));
});

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(doLogin.fulfilled, (state, action) => {
      state.token = action.payload;
    });
    builder.addCase(doLogout.fulfilled, (state) => {
      state.token = '';
    });
  },
});

export default authSlice.reducer;
